import { gql } from '@apollo/client'

export const PMS_MAPPING_LIST_FOR_ACCOMMODATION_QUERY = gql`
  query PMSMappingListForAccommodation(
    $propertyCode: String!
    $providerCode: String!
    $providerAdapter: ProviderAdapter!
  ) {
    pmsMappingListForAccommodation(
      propertyCode: $propertyCode
      providerCode: $providerCode
      providerAdapter: $providerAdapter
    ) {
      PMSCode
      PMSPass
      AdotelCode
      Active
      RoomTypes {
        AdotelCode
        AdotelName
        PMSCode
        Active
        RatePlans {
          AdotelCode
          AdotelName
          PMSCode
          Active
        }
      }
    }
  }
`

export const PMS_MAPPING_LIST_FOR_CHANNEL_QUERY = gql`
  query PMSMappingListForChannel(
    $propertyCode: String!
    $providerCode: String!
    $providerAdapter: ProviderAdapter!
  ) {
    pmsMappingListForChannel(
      propertyCode: $propertyCode
      providerCode: $providerCode
      providerAdapter: $providerAdapter
    ) {
      PMSCode
      PMSPass
      AdotelCode
      AdotelName
      Active
      RoomTypes {
        AdotelCode
        AdotelName
        PMSCode
        Active
        RatePlans {
          AdotelCode
          AdotelName
          PMSCode
          Active
        }
      }
    }
  }
`

export const CREATE_PMS_MAPPING_FOR_ACCOMMODATION_MUTATION = gql`
  mutation CreatePMSMappingForAccommodation(
    $input: PMSMappingForAccommodation!
  ) {
    createPMSMappingForAccommodation(input: $input) {
      message
    }
  }
`

export const MODIFY_PMS_MAPPING_FOR_ACCOMMODATION_MUTATION = gql`
  mutation modifyPMSMappingForAccommodation(
    $input: PMSMappingForAccommodation!
  ) {
    modifyPMSMappingForAccommodation(input: $input) {
      message
    }
  }
`

export const CREATE_PMS_MAPPING_FOR_CHANNEL_MUTATION = gql`
  mutation CreatePMSMappingForChannel($input: PMSMappingForChannel!) {
    createPMSMappingForChannel(input: $input) {
      message
    }
  }
`

export const MODIFY_PMS_MAPPING_FOR_CHANNEL_MUTATION = gql`
  mutation ModifyPMSMappingForChannel($input: PMSMappingForChannel!) {
    modifyPMSMappingForChannel(input: $input) {
      message
    }
  }
`
